if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        this.setupCounter();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      setupCounter() {
        const container = this.querySelector('[role="document"]');
        const dialog = this.querySelector('.product-media-modal__dialog');
        if (!container || !dialog) return;

        if (!this.counter) {
          this.counter = document.createElement('div');
          this.counter.className = 'product-media-modal__counter';
          this.counter.setAttribute('aria-hidden', 'true');
          dialog.appendChild(this.counter);
          container.addEventListener('scroll', () => this.updateCounter(container), { passive: true });
        }

        this.updateCounter(container);
      }

      updateCounter(container) {
        const slides = Array.from(container.children).filter((el) => el.offsetWidth > 0);
        const total = slides.length;

        if (total < 2 || !container.clientWidth) {
          this.counter.textContent = '';
          return;
        }

        const index = Math.min(total - 1, Math.max(0, Math.round(container.scrollLeft / container.clientWidth)));
        this.counter.textContent = `${index + 1} / ${total}`;
      }
    }
  );
}